import { normalizeDeviceType, supportsSignalStrength } from '../../utils/deviceTypes';

const inventorySummaryCache = new WeakMap();

const normalizeVin = (value) => {
  if (!value) {
    return '';
  }

  return String(value).trim().toUpperCase();
};

export const getDeviceVin = (device) => normalizeVin(device?.vin);

const buildDeviceInventorySummary = (device) => {
  const wiviDetail = device?.wivi_detail ?? null;
  const signalDeviceType = normalizeDeviceType(
    device?.remote_device_type ??
    device?.inventory_device_type ??
    device?.device_type ??
    wiviDetail?.device_type ??
    wiviDetail?.remote_device_type ??
    wiviDetail?.local_device?.device_type ??
    null
  );
  const signalSupported = supportsSignalStrength(signalDeviceType);

  return {
    online: device?.inventory_online ?? null,
    logging: device?.inventory_logging ?? null,
    running: device?.inventory_running ?? null,
    signalBars: signalSupported
      ? device?.inventory_signal_bars ??
        wiviDetail?.status_payload?.signalBars?.value ??
        wiviDetail?.status_signal_bars ??
        null
      : null,
    networkType: device?.inventory_network_type ?? null,
    signalDeviceType,
    signalSupported,
    lastUpdated: device?.inventory_last_updated ?? null,
    syncedAt: device?.inventory_synced_at ?? null,
    snapshotId: device?.wivi_snapshot_id ?? device?.wivi_detail?.id ?? null,
    displayName: device?.display_name ?? device?.vehicle_name ?? null,
    remoteDeviceName: device?.remote_device_name ?? null,
    remoteDeviceType: device?.remote_device_type ?? null,
    remoteFleetName: device?.remote_fleet_name ?? null,
    remoteFleetId: device?.remote_fleet_id ?? null,
    remoteOrganizationName: device?.remote_organization_name ?? null,
    remoteOrganizationId: device?.remote_organization_id ?? null,
    make: device?.make ?? null,
    model: device?.model ?? null,
    year: device?.year ?? null,
    clientVersion: device?.client_version ?? null,
    wiviDetail: device?.wivi_detail ?? null,
    wiviMatchStatus: device?.wivi_match_status ?? device?.wivi_match?.status ?? null,
    wiviMatchReason: device?.wivi_match_reason ?? device?.wivi_match?.reason ?? null,
    loggerMatchStatus: device?.logger_match_status ?? device?.logger_match?.status ?? null,
  };
};

export const getDeviceInventorySummary = (device) => {
  if (!device || typeof device !== 'object') {
    return buildDeviceInventorySummary(device);
  }

  const cachedSummary = inventorySummaryCache.get(device);
  if (cachedSummary) {
    return cachedSummary;
  }

  const summary = buildDeviceInventorySummary(device);
  inventorySummaryCache.set(device, summary);
  return summary;
};

export const getDeviceLoggerSummary = (device) => ({
  totalLogs: device?.logger_total_logs ?? null,
  firstSeen: device?.logger_first_seen ?? null,
  lastSeen: device?.logger_last_seen ?? null,
  updatedAt: device?.logger_updated_at ?? null,
});

export const getDeviceInsightSummary = (device) => ({
  vin: getDeviceVin(device),
  inventory: getDeviceInventorySummary(device),
  logger: getDeviceLoggerSummary(device),
});